export interface Services {
    serviceNumber: string;
}

export enum ServicesType {
    Agents = 'agents',
    Vehicles = 'vehicles'
}
